// import React, { useState, useEffect } from "react";
// import { ethers } from "../../../node_modules/ethers/dist/ethers";
// import shape01 from "../../assets/img/banner/koala.png";
// import shape02 from "../../assets/img/images/bnb-svg.svg";
// import Web3 from "web3";

// import shape03 from "../../assets/img/images/usdt.svg";
// import fireIcon from "../../assets/img/icon/fire.png";
// import CountDownOne from "../CountDown/CountDownOne";

// const Banner = (props) => {
//   const [activeCurrency, setActiveCurrency] = useState('BNB');
//   const [amount, setAmount] = useState("");
//   const [tokensReceived, setTokensReceived] = useState("");

//   const handleButtonClick = (currency) => {
//     setActiveCurrency(currency);
//   };

//   const [web3, setWeb3] = useState(null);
//   const [connectedAddress, setConnectedAddress] = useState(null);
//   const [buttonText, setButtonText] = useState("Connect");

//   useEffect(() => {
//     // Check if Web3 is already injected
//     if (window.ethereum) {
//       const web3Instance = new Web3(window.ethereum);
//       setWeb3(web3Instance);

//       // Check if user is already connected
//       web3Instance.eth.getAccounts()
//         .then(accounts => {
//           if (accounts.length > 0) {
//             setConnectedAddress(accounts[0]);
//             setButtonText(truncateAddress(accounts[0]));
//           }
//         })
//         .catch(error => {
//           console.error("Error getting accounts:", error.message);
//         });
//     }
//   }, []);

//   const truncateAddress = (address) => {
//     if (!address) return "";
//     const start = address.substring(0, 5);
//     const end = address.substring(address.length - 5);
//     return `${start}.....${end}`;
//   };

//   const connectWallet = async () => {
//     try {
//       // Request account access
//       await window.ethereum.request({ method: "eth_requestAccounts" });
//       const accounts = await web3.eth.getAccounts();
//       const connectedAccount = accounts[0];

//       if (connectedAccount) {
//         setConnectedAddress(connectedAccount);
//         setButtonText(truncateAddress(connectedAccount));
//         // You can perform additional actions after successful connection
//       }
//     } catch (error) {
//       console.error("Error connecting wallet:", error.message);
//     }
//   };



//   return (
//     <section className="banner-area banner-bg">
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-md-6">
//             <div className="banner-content text-center">
//               <img src={shape01} className="main-image" alt="Main" />
//             </div>
//           </div>

//           <div className="col-md-6">
//             <div className="banner-content text-center">
//               <div className="box">
//                 <div className="row">
//                   <h3 className="presale-heading">
//                     Dive Into KOALIA Forest and Buy
//                   </h3>    
//                 </div>
//                 <div className="row">  
//                   <h4 className="presale-heading1">
//                     $KOALIA Today
//                   </h4>
//                 </div>   

//                 <div className="row">
//                   <p className="presale-para">
//                     1 KOALIA = $0.013
//                   </p>
//                 </div>

//                 <div className="row justify-content-center">
//                   <div className="col-lg-12 button-row" style={{ display: 'flex', justifyContent: 'center' }}>
//                     <button
//                       className={`BNB currency-button ${activeCurrency === 'BNB' ? 'active' : ''}`}
//                       onClick={() => handleButtonClick('BNB')}
//                     >
//                       <img className="bnb-image" src={shape02} alt="BNB" /> BNB
//                     </button>
//                     <button
//                       className={`USDT currency-button ${activeCurrency === 'USDT' ? 'active' : ''}`}
//                       onClick={() => handleButtonClick('USDT')}
//                     >
//                       <img className="usdt-image" src={shape03} alt="USDT" /> USDT
//                     </button>
//                     <button
//                       className={`USDC currency-button ${activeCurrency === 'USDC' ? 'active' : ''}`}
//                       onClick={() => handleButtonClick('USDC')}
//                     >
//                       <img className="usdc-image" src={"https://cryptologos.cc/logos/usd-coin-usdc-logo.svg?v=032"} alt="USDC" /> USDC
//                     </button>
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-12 placeholders">
//                     <p className="amount">
//                       Amount in {activeCurrency}
//                       <br />
//                       <input 
//                         type="text" 
//                         placeholder={activeCurrency} 
//                         value={amount}
//                         onChange={(e) => setAmount(e.target.value)}
//                       />
//                     </p>
//                     <p className="amount">
//                       Tokens Receive
//                       <br />
//                       <input 
//                         type="text" 
//                         placeholder="" 
//                         value={tokensReceived}
//                         onChange={(e) => setTokensReceived(e.target.value)}
//                       />
//                     </p>
//                   </div>
//                 </div>

//                 <button className="btn" onClick={connectWallet}>{buttonText}</button>
//                 <button className="btn">Buy Tokens</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Banner;


import React, { useState, useEffect } from "react";
// import { ethers } from "ethers";
import Web3 from "web3";
import shape01 from "../../assets/img/banner/koala.png";
import shape02 from "../../assets/img/images/bnb-svg.svg";
import shape03 from "../../assets/img/images/usdt.svg";
import fireIcon from "../../assets/img/icon/fire.png";
import CountDownOne from "../CountDown/CountDownOne";
import presaleAbi from "./presaleAbi.json"; // Save your ABI as a JSON file and import it

const presaleAddress = "0x51E7Dd48a23DBfCF2242F1d063c65d0560418306"; // Presale contract address

const Banner = (props) => {
  const [activeCurrency, setActiveCurrency] = useState("BNB");
  const [amount, setAmount] = useState("");
  const [tokensReceived, setTokensReceived] = useState("");
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [connectedAddress, setConnectedAddress] = useState(null);
  const [buttonText, setButtonText] = useState("Connect");

    const handleButtonClick = (currency) => {
    setActiveCurrency(currency);
  };


  useEffect(() => {
    if (window.ethereum) {
      const web3Instance = new Web3(window.ethereum);
      setWeb3(web3Instance);
      const contractInstance = new web3Instance.eth.Contract(presaleAbi, presaleAddress);
      setContract(contractInstance);

      web3Instance.eth.getAccounts().then((accounts) => {
        if (accounts.length > 0) {
          setConnectedAddress(accounts[0]);
          setButtonText(truncateAddress(accounts[0]));
        }
      }).catch((error) => {
        console.error("Error getting accounts:", error.message);
      });
    }
  }, []);

  const truncateAddress = (address) => {
    if (!address) return "";
    const start = address.substring(0, 5);
    const end = address.substring(address.length - 5);
    return `${start}.....${end}`;
  };

  const connectWallet = async () => {
    try {
      await window.ethereum.request({ method: "eth_requestAccounts" });
      const accounts = await web3.eth.getAccounts();
      const connectedAccount = accounts[0];
      if (connectedAccount) {
        setConnectedAddress(connectedAccount);
        setButtonText(truncateAddress(connectedAccount));
      }
    } catch (error) {
      console.error("Error connecting wallet:", error.message);
    }
  };

  const calculateTokensReceived = (amount) => {
    const tokenPriceUSD = 0.013;
    return (amount / tokenPriceUSD).toFixed(2);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);
    if (value && !isNaN(value)) {
      setTokensReceived(calculateTokensReceived(value));
    } else {
      setTokensReceived("");
    }
  };

  // const buyTokens = async () => {
  //   if (!connectedAddress || !contract || !amount) {
  //     alert("Please connect your wallet and enter a valid amount.");
  //     return;
  //   }

  //   try {
  //     if (activeCurrency === "BNB") {
  //       await contract.methods.buyTokens().send({
  //         from: connectedAddress,
  //         value: ethers.utils.parseEther(amount)
  //       });
  //     } else if (activeCurrency === "USDT") {
  //       await contract.methods.buyWithUSDT(ethers.utils.parseUnits(amount, 6)).send({
  //         from: connectedAddress
  //       });
  //     } else if (activeCurrency === "USDC") {
  //       await contract.methods.buyWithUSDC(ethers.utils.parseUnits(amount, 6)).send({
  //         from: connectedAddress
  //       });
  //     }
  //     alert("Purchase successful!");
  //   } catch (error) {
  //     console.error("Error buying tokens:", error.message);
  //     alert("Error buying tokens.");
  //   }
  // };

  
  const buyTokens = async () => {
    if (!connectedAddress || !contract || !amount) {
      alert("Please connect your wallet and enter a valid amount.");
      return;
    }
  
    try {
      if (activeCurrency === "BNB") {
        await contract.methods.buyTokens().send({
          from: connectedAddress,
          value: web3.utils.toWei(amount, 'ether')
        });
      } else if (activeCurrency === "USDT") {
        const usdtAmount = web3.utils.toWei(amount, 'wei'); // USDT typically uses 18 decimal places
        await contract.methods.buyWithUSDT(usdtAmount).send({
          from: connectedAddress
        });
      } else if (activeCurrency === "USDC") {
        const usdcAmount = web3.utils.toWei(amount, 'wei'); // USDC typically uses 18 decimal places
        await contract.methods.buyWithUSDC(usdcAmount).send({
          from: connectedAddress
        });
      }
      alert("Purchase successful!");
    } catch (error) {
      console.error("Error buying tokens:", error.message);
      alert("Error buying tokens.");
    }
  };
  
  return (
    <section className="banner-area banner-bg">
      <div className="container">
      <h2 className="heading-main">KOALIA</h2>

        <div className="row justify-content-center">
        
          <div className="col-md-6">
            <div className="banner-content text-center">
              <img src={shape01} className="main-image" alt="Main" />
            </div>
          </div>

          <div className="col-md-6" id="presale">
            <div className="banner-content text-center">
              <div className="box">
                <div className="row">
                  <h3 className="presale-heading">Dive Into KOALIA Forest and Buy</h3>
                </div>
                <div className="row">
                  <h4 className="presale-heading1">$KOALIA Today</h4>
                </div>

                <div className="row">
                  <p className="presale-para">1 KOALIA = $0.013</p>
                </div>

                <div className="row justify-content-center">
                  <div className="col-lg-12 button-row" style={{ display: "flex", justifyContent: "center" }}>
                    <button className={`BNB currency-button ${activeCurrency === "BNB" ? "active" : ""}`} onClick={() => handleButtonClick("BNB")}>
                      <img className="bnb-image" src={shape02} alt="BNB" /> BNB
                    </button>
                    <button className={`USDT currency-button ${activeCurrency === "USDT" ? "active" : ""}`} onClick={() => handleButtonClick("USDT")}>
                      <img className="usdt-image" src={shape03} alt="USDT" /> USDT
                    </button>
                    <button className={`USDC currency-button ${activeCurrency === "USDC" ? "active" : ""}`} onClick={() => handleButtonClick("USDC")}>
                      <img className="usdc-image" src={"https://cryptologos.cc/logos/usd-coin-usdc-logo.svg?v=032"} alt="USDC" /> USDC
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 placeholders">
                    <p className="amount">
                      Amount in {activeCurrency}
                      <br />
                      <input type="text" placeholder={activeCurrency} value={amount} onChange={handleAmountChange} />
                    </p>
                    <p className="amount">
                      Tokens Receive
                      <br />
                      <input type="text" placeholder="" value={tokensReceived} readOnly />
                    </p>
                  </div>
                </div>

                <button className="btn" onClick={connectWallet}>{buttonText}</button>
                <button className="btn" onClick={buyTokens}>Buy Tokens</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
